import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const AssignByContent = createApi({
  reducerPath: "assignByContentApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getContentProgress: builder.query({
      query: ({ pageNo, searchId, searchName }: any) => ({
        url: "/graphql",
        body: gql`
         query{
           fetchContentsAssignmentProgress(
            request: {
            artifactNames: ${searchName ? `["${searchName}"]` : "[]"}
            artifactId: ${searchId ? `["${searchId}"]` : "[]"}
            }
            criteria: {
            sortKey: "_score", 
            order: "ASC", 
            pageNo: ${pageNo}, 
            pageCount: 10
            }
        ) {
             timestamp
            version
            error
            data {
            contents {
                artifactId
                artifactType
                title
                shortDescription
                longDescription
                language
                duration
                difficultyLevel
                branding {
                    banner
                    thumbnail
                    promo
                }
                sourceName
                sourceType
                prerequisite
                learningObjective
                demonstrableOutcome
                brandingurls {
                    banner
                    thumbnail
                    promo
                }
                searchTags {
                    defaultTag
                }
                createdBy {
                id
                name {
                    fullName
                    firstName
                    lastName
                }
                email
                profileImageUrl
                employment {
                    bg
                    du
                    band
                    role
                    grade
                    title
                    clientName
                    designation
                    organization
                    operatingUnit
                    assignmentStatus
                }
                }
                totalAssignments
                completedAssignments
                percentageCompleted
            }
            pageNumber
            pageSize
            totalCount
            }
  }
}
        `
      }),
      extraOptions: { service: "Catalog" },
      serializeQueryArgs: ({ endpointName }) => {
        return { endpointName };
      },
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs?.arg?.pageNo > 0) {
          const messageMap = new Map();
          [
            ...currentCacheData?.fetchContentsAssignmentProgress?.data
              ?.contents,
            ...responseData.fetchContentsAssignmentProgress?.data?.contents
          ].map((msg) => {
            if (!messageMap.has(msg.artifactId)) {
              messageMap.set(msg.artifactId, msg);
            }
          });
          const mergedResult = [...messageMap.values()];
          return {
            ...responseData,
            fetchContentsAssignmentProgress: {
              ...responseData.fetchContentsAssignmentProgress,
              data: {
                ...responseData.fetchContentsAssignmentProgress.data,
                contents: mergedResult
              }
            }
          };
        } else return responseData;
      }
    })
  })
});

export const { useGetContentProgressQuery, useLazyGetContentProgressQuery } =
  AssignByContent;
